export default __webpack_public_path__ + "static/media/HowToExt1.8997876b.gif";